import styles from "./MobileBlock.module.scss";
import {format} from "date-fns";
import React from "react";
import {useNavigate} from "react-router-dom";
import {ru} from "date-fns/locale";

const MobileBlocksSchedule = ({games, setToDelete}) => {

    const navigate = useNavigate();

    return (
        <div className={styles.mobileBlocksWrapper}>
            {
                games.map((game,index) => (
                    <div key={index} className={`${styles.mobileBlock} ${game.isEnding && styles.ended}`}>
                        <div className={styles.mobileBlockRow}>
                            <div className={styles.leftBLock}>
                                <span>
                                     {format(new Date(game.startedAt), "dd.MM.yy 'в' HH:mm", { locale: ru })}
                                </span>
                                <br/>
                                <div className={styles.mobileTitle}>
                                    {game.title}
                                </div>
                            </div>
                            <div className={styles.rightBLock}>
                                <span className={`opacity-50`}>
                                    Зал:
                                </span>
                                {game.room}
                            </div>
                        </div>

                        <div className={styles.mobileBlockRow}>
                            <div className={styles.leftBLock}>
                                <p className={`opacity-50`}>
                                    Мастер:
                                </p>
                                <p>
                                    {game.gameMaster}
                                </p>
                            </div>
                            <div className={styles.rightBLock}>
                                <p className={`opacity-50`}>
                                    Кол-во игроков:
                                </p>
                                <p>
                                    {game.currentCountPlayers} из {game.maxCountPlayers}
                                </p>
                            </div>
                        </div>

                        <div className={styles.mobileBlockFooter}>
                            <button
                                className={"btn-word col d-flex justify-content-center align-items-center"}
                                onClick={() => navigate(`/admin/schedule/edit/${game.id}`)}
                            >
                                Редактировать
                            </button>
                            {setToDelete && (
                                <button
                                    className={"btn-word col d-flex justify-content-center align-items-center " + styles.btnDel}
                                    onClick={() => setToDelete(game)}
                                >
                                    Удалить
                                </button>
                            )}

                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default MobileBlocksSchedule;